import { StatsMetric } from './enums';

export enum StatisticsUnit {
  Kilowatt = 'kilowatt',
  Percent = 'percent',
  Celsius = 'celsius',
  MeterPerSecond = 'meter-per-second',
  Ampere = 'ampere',
}

export const statisticsVariables = [
  'PV_POWER_GRAPH',
  'PV_POWER_STRING_GRAPH',
  'HW_POWER_GRAPH',
  'HW_POWER_PHASE_GRAPH',
  'HP_CONSUMED_GRAPH',
  'EM_CONSUMED_PHASE_GRAPH',
  'EM_CONSUMED_GRAPH',
  'EM_OVERFLOW_PHASE_GRAPH',
  'EM_OVERFLOW_GRAPH',
  'PL_POWER_GRAPH',
  'WB_CONSUMED_GRAPH',
  'PV_BATTERY_SOC_GRAPH',
  'PV_BATTERY_CHARGE_GRAPH',
  'PV_BATTERY_DISCHARGE_GRAPH',
  'HW_TEMP_GRAPH',
  'THERMOSTAT_TEMP_GRAPH',
  'OUTDOOR_TEMP_GRAPH',
  'WIND_POWER_GRAPH',
  'WIND_SPEED_GRAPH',
  'WIND_BATTERY_CHARGE_POWER_GRAPH',
  'WIND_LOAD_CURRENT_GRAPH',
  'HOME_CONSUMPTION',
  'EM_METER_POWER_GRAPH',
] as const;

export type StatisticsVariableId = typeof statisticsVariables[number];

type StatisticsConfigItem = {
  dbName: StatsMetric;
  unit: StatisticsUnit;
  subStats?: StatsMetric;
};

export const statisticsConfig: Record<
  StatisticsVariableId,
  StatisticsConfigItem
> = {
  PV_POWER_GRAPH: {
    dbName: StatsMetric.PV_POWER_GRAPH,
    unit: StatisticsUnit.Kilowatt,
    subStats: StatsMetric.PV_POWER_STRING_GRAPH,
  },
  PV_POWER_STRING_GRAPH: {
    dbName: StatsMetric.PV_POWER_STRING_GRAPH,
    unit: StatisticsUnit.Kilowatt,
    subStats: StatsMetric.PV_POWER_STRING_GRAPH,
  },
  HW_POWER_GRAPH: {
    dbName: StatsMetric.HW_POWER_GRAPH,
    unit: StatisticsUnit.Kilowatt,
    subStats: StatsMetric.HW_POWER_PHASE_GRAPH,
  },
  HW_POWER_PHASE_GRAPH: {
    dbName: StatsMetric.HW_POWER_PHASE_GRAPH,
    unit: StatisticsUnit.Kilowatt,
  },
  HP_CONSUMED_GRAPH: {
    dbName: StatsMetric.HP_CONSUMED_GRAPH,
    unit: StatisticsUnit.Kilowatt,
  },
  EM_CONSUMED_GRAPH: {
    dbName: StatsMetric.EM_CONSUMED_GRAPH,
    unit: StatisticsUnit.Kilowatt,
    subStats: StatsMetric.EM_CONSUMED_PHASE_GRAPH,
  },
  EM_CONSUMED_PHASE_GRAPH: {
    dbName: StatsMetric.EM_CONSUMED_PHASE_GRAPH,
    unit: StatisticsUnit.Kilowatt,
  },
  EM_OVERFLOW_GRAPH: {
    dbName: StatsMetric.EM_OVERFLOW_GRAPH,
    unit: StatisticsUnit.Kilowatt,
    subStats: StatsMetric.EM_OVERFLOW_PHASE_GRAPH,
  },
  EM_OVERFLOW_PHASE_GRAPH: {
    dbName: StatsMetric.EM_OVERFLOW_PHASE_GRAPH,
    unit: StatisticsUnit.Kilowatt,
  },
  PL_POWER_GRAPH: {
    dbName: StatsMetric.PL_POWER_GRAPH,
    unit: StatisticsUnit.Kilowatt,
  },
  WB_CONSUMED_GRAPH: {
    dbName: StatsMetric.WB_CONSUMED_GRAPH,
    unit: StatisticsUnit.Kilowatt,
    subStats: StatsMetric.WB_CONSUMED_GRAPH,
  },
  PV_BATTERY_SOC_GRAPH: {
    dbName: StatsMetric.PV_BATTERY_SOC_GRAPH,
    unit: StatisticsUnit.Percent,
  },
  PV_BATTERY_CHARGE_GRAPH: {
    dbName: StatsMetric.PV_BATTERY_CHARGE_GRAPH,
    unit: StatisticsUnit.Kilowatt,
    subStats: StatsMetric.PV_BATTERY_CHARGE_GRAPH, // self-reference signs only sub-stats entries exists
  },
  PV_BATTERY_DISCHARGE_GRAPH: {
    dbName: StatsMetric.PV_BATTERY_DISCHARGE_GRAPH,
    unit: StatisticsUnit.Kilowatt,
    subStats: StatsMetric.PV_BATTERY_DISCHARGE_GRAPH, // self-reference signs only sub-stats entries exists
  },
  HW_TEMP_GRAPH: {
    dbName: StatsMetric.HW_TEMP_GRAPH,
    unit: StatisticsUnit.Celsius,
  },
  THERMOSTAT_TEMP_GRAPH: {
    dbName: StatsMetric.THERMOSTAT_TEMP_GRAPH,
    unit: StatisticsUnit.Celsius,
  },
  OUTDOOR_TEMP_GRAPH: {
    dbName: StatsMetric.OUTDOOR_TEMP_GRAPH,
    unit: StatisticsUnit.Celsius,
  },
  WIND_POWER_GRAPH: {
    dbName: StatsMetric.WIND_POWER_GRAPH,
    unit: StatisticsUnit.Kilowatt,
  },
  WIND_BATTERY_CHARGE_POWER_GRAPH: {
    dbName: StatsMetric.WIND_BATTERY_CHARGE_POWER_GRAPH,
    unit: StatisticsUnit.Kilowatt,
  },
  WIND_SPEED_GRAPH: {
    dbName: StatsMetric.WIND_SPEED_GRAPH,
    unit: StatisticsUnit.MeterPerSecond,
  },
  WIND_LOAD_CURRENT_GRAPH: {
    dbName: StatsMetric.WIND_LOAD_CURRENT_GRAPH,
    unit: StatisticsUnit.Ampere,
  },
  HOME_CONSUMPTION: {
    dbName: StatsMetric.HOME_CONSUMPTION,
    unit: StatisticsUnit.Kilowatt,
  },
  EM_METER_POWER_GRAPH: {
    dbName: StatsMetric.EM_METER_POWER_GRAPH,
    unit: StatisticsUnit.Kilowatt,
    subStats: StatsMetric.EM_METER_POWER_GRAPH,
  },
};
